<template>
	<div
		class="tab-list"
		role="tablist"
	>
		<template
			v-for="(tab, i) in tabs"
			:key="tab.value"
		>
			<TabItem
				:title="tab.title"
				:sub-text="tab.subText"
				:disabled="tab.disabled"
				:active="isActive(tab)"
				@selected="onSelect(tab.value)"
			>
				<template
					v-for="(_, name) in $slots"
					#[name]="slotProps"
				>
					<slot
						:name="name"
						v-bind="slotProps || {}"
					/>
				</template>
			</TabItem>
			<TabSeparator v-if="i < tabs.length - 1" />
		</template>
	</div>
</template>

<script setup lang="ts">
import TabItem, { type TabItemProps } from './internals/TabItem.vue';
import TabSeparator from './internals/TabSeparator.vue';

interface TabListProps {
	tabs: (TabItemProps & { value: string | number})[]
}
const modelValue = defineModel<string | number>();
defineProps<TabListProps>();

const isActive = (tab: TabItemProps & { value: string | number }) => tab.value === modelValue.value;
const onSelect = (value: string | number) => {
	modelValue.value = value;
};
</script>

<style lang="scss" scoped>
.tab-list {
	min-height: 9.4rem;
	overflow: hidden;
	background: white;
	width: 100%;
	display: flex;
	align-items: stretch;
	justify-content: center;
	border-radius: $border-radius-large;
	box-shadow: $box-shadow;
}
</style>
